<div class="container">
  <div class="row">
    <div class="col-md-12">
      <app-header></app-header>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <app-footer></app-footer>
    </div>
  </div>
</div>